<template>
  <v-menu
    ref="menu"
    :value="isMenuOpen"
    :close-on-content-click="true"
    :close-on-click="true"
    transition="scale-transition"
    offset-y
    min-width="200"
    max-width="500"
    eager
    z-index="100"
  >
    <template v-slot:activator="{ on, attrs }">
      <slot name="activator" v-bind="{ on, attrs }" />
    </template>
    <div class="background">
      <div class="d-flex">
        <div class="title-text pa-4 text-h6">{{ $t('fzgSelection') }}</div>
        <v-spacer></v-spacer>
        <v-btn icon class="ma-3" @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <div class="FZSelector fz-menu-container background" style="max-height: calc(100vh - 120px); overflow-y: scroll" v-click-outside="onClose">
        <template v-if="showVehiclesByCategory">
          <v-row class="d-flex pa-2" v-for="(category, categoryIndex) in vehiclesByCategory" :key="categoryIndex">
            <v-col v-if="vehiclesByCategory.length > 1" class="pa-2 text-h6" cols="12">{{ category.category }}</v-col>
            <v-col class="d-flex flex-wrap row">
              <div class="d-flex flex-column" v-for="vehicle in category.vehicles" :key="vehicle.id">
                <v-btn class="ma-1" outlined rounded text @click="onVehicleSelected(vehicle)">{{ vehicle.fzName }} </v-btn>
              </div>
            </v-col>
          </v-row>
        </template>
        <v-data-table
          v-else
          item-key="id"
          fixed-header
          :headers="headers"
          :items="vehicles"
          :items-per-page="vehicles.length"
          hide-default-footer
          @click:row="(v) => onVehicleSelected(v)"
        />
      </div>
    </div>
  </v-menu>
</template>

<script>
import common from '@/mixins/common';
import { mapState } from 'vuex';

export default {
  name: 'FzSelector',
  mixins: [common],
  props: {
    isMenuOpen: {
      type: Boolean,
      default: false,
    },
    context: String, //either wagenbuch or unfalldesk => defines which store is used to get vehicles
  },
  data() {
    return {
      fzTypIndex: 0,
      closeHandlerActive: false,
      headers: [
        { text: this.$t('fzgNummer'), value: 'fzName' },
        { text: this.$t('wagenbuch.fahrzeug.typ'), value: 'typName' },
        { text: this.$t('wagenbuch.fahrzeug.art'), value: 'fzTyp' },
      ],
    };
  },

  computed: {
    ...mapState({
      tenant: (state) => state.profile.customerRelations?.tenant,
    }),
    showVehiclesByCategory() {
      if (this.tenant === 'vzo') {
        return false;
      }
      return true;
    },
    fzByTyp() {
      // if (!this.$store.state.wagenbuch.fzByTyp) return undefined;
      if (this.context === 'wagenbuch') {
        // in-accurate: if (Object.keys(this.$store.state.wagenbuch.fzByTyp).length > 0) {
        return this.$store.state.wagenbuch.fzByTyp;
      } else {
        return this.$store.state.unfalldesk.fzByTyp;
      }
    },
    vehicles() {
      if (this.context === 'wagenbuch') {
        return this.$store.state.wagenbuch.fahrzeuge;
      } else {
        return this.$store.state.unfalldesk.fahrzeuge;
      }
    },
    vehiclesByCategory() {
      const vehiclesByCategory = {};
      this.vehicles.forEach((v) => {
        if (!vehiclesByCategory[v.fzTyp]) vehiclesByCategory[v.fzTyp] = [];
        vehiclesByCategory[v.fzTyp].push(v);
      });

      return Object.keys(vehiclesByCategory)
        .sort((a, b) => (typeof a === 'string' ? a.localeCompare(b) : -1))
        .map((category) => {
          return {
            category,
            vehicles: vehiclesByCategory[category].sort((v1, v2) => (v1.fzName ? v1.fzName.localeCompare(v2.fzName) : -1)),
          };
        });
    },
  },
  methods: {
    onVehicleSelected(vehicle) {
      this.$emit('change', vehicle);
      this.onClose();
    },
    onClose() {
      if (this.closeHandlerActive) {
        this.closeHandlerActive = false;
        this.$emit('close');
      }
    },
  },
  watch: {
    isMenuOpen(newVal) {
      if (newVal) {
        // Needed because v-click-outside fires on open
        setTimeout(() => (this.closeHandlerActive = true), 200);
      }
    },
  },
};
</script>

<style scoped>
.fz-menu-container {
  overflow-x: auto;
  max-height: calc(100vh - 120px);
  overflow-y: scroll;
  padding: 16px;
}
</style>
